import RelateProductComponent from './relate-product'
import AppRelateProductModal from "layout/components/modal/relate-product-modal/relate-product-modal";
import {disconnectListing} from "@/api/sale";
/**
 * 批量关联
 * @param mskuList msku集合
 */
const batchRelateProduct = function (mskuList)  {
    const modal = this.$gjCreate(AppRelateProductModal, {
        props: {
            ids: this.selectedRows.map(v => v.id),
            mode: 'batch'
        },
        on: {
            after() {
                this.$gjResetPage();
                modal.$gjDestroy();
            }
        }
    })
}

/**
 * 解除关联
 * @param id 行id
 */
const disconnectRelateProduct = function(id) {
    const modal = this.$gjCreate('gj-info-modal', {
        props: {
            content: '您确定要解除该商品的关联关系吗?'
        },
        on: {
            cancel() {
                modal.$gjDestroy();
            },
            confirm() {
                modal.confirmLoading = true;
                disconnectListing(id)
                    .then(() => {
                        this.$gjMessage.success('操作成功');
                        this.$gjResetPage();
                        modal.$gjDestroy();
                    }).complete(() => modal.confirmLoading)
            }
        }
    })
}

// batchRelateProduct, disconnectRelateProduct 方法外部使用call或apply调用
export  {
    RelateProductComponent,
    batchRelateProduct,
    disconnectRelateProduct
}
